export default class workPlanCreateModalCtrl {

  constructor ($scope, $mdDialog, WorkPlanParametrizationSrv) {
    $scope.workPlanId
    $scope.clonePlan = false

    $scope.close = function () {
      $mdDialog.hide()
    }

    $scope.getWorkPlanList = function () {
      WorkPlanParametrizationSrv.getWorkPlans.get().$promise.then((dataReturn) => {
        if (dataReturn.status === true) {
          $scope.workPlanList = dataReturn.data
        } else {
          console.log(dataReturn)
        }
      })
    }

    $scope.selectWorkPlan = function () {
      $scope.getWorkPlanList()
      $scope.clonePlan = true
    }
  }
}

workPlanCreateModalCtrl.$inject = ['$scope', '$mdDialog', 'WorkPlanParametrizationSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workPlanParametrization/create/workPlanCreateModalCtrl.js